import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import AccountProgressStageComponent from 'webapp/components/account-progress/stage';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';

export default class AccountProgressPageComponent extends Component {
	@service('account-progress') declare accountProgressService: Service.AccountProgress;
	@service('account') declare accountService: Service.Account;
	<template>
		<div id="accountProgress">

			{{#unless this.accountService.hideDataboxNotWhiteLabeledContentForNonAdmins}}
				<div class="intro">
					<CommonUiIconComponent @name="Badge" @size="2xl" />
					<strong>{{this.accountProgressService.introTitle}}</strong>
					<p>{{this.accountProgressService.introText}}</p>
				</div>
			{{/unless}}

			<div
				class="flex-ct flex-ct--size-stage stages
					{{if this.accountService.isAgency 'agency'}}"
			>
				{{#each this.accountProgressService.stagesData as |stage|}}
					<AccountProgressStageComponent @model={{stage}} />
				{{/each}}
				<li class="flex-item flex-item--fake"></li>
				<li class="flex-item flex-item--fake"></li>
			</div>

		</div>
	</template>
}
